/**
 * Cross-engine migration workspace module.
 *
 * Registers the 'cross-engine-migrate' workspace type. The component + run
 * store live in the `cross-engine-migrate` feature folder; this thin module only
 * wires it into the workspace registry (mirrors `schema-compare/index.ts`).
 */
import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'cross-engine-migrate',
  lazyWorkspaceTab(() => import('../../cross-engine-migrate/components/CrossEngineMigrateTab').then((m) => ({ default: m.CrossEngineMigrateTab }))),
);

